export const brandName = "吃瓜直播";
export const brandSlogan = "瓜从哪吃起？带带你，不迷路";
export const brandEmail = "hello@chigua-live.cn";

export const navItems = [
  { key: "#hot", label: "热门现场" },
  { key: "#scene", label: "连麦直击" },
  { key: "#services", label: "吃瓜服务" },
  { key: "#faq", label: "常见问题" },
  { key: "#about", label: "关于我们" },
];

export const hotWords = [
  "蹲个后续", "催更指路", "连麦开撕", "正面回应", "爆料现场", "当事人下场",
  "隔空喊话", "评论区吵翻", "反转来了", "催更姐妹团", "指路合集", "现场对质",
];

export const filterTabs = ["全部", "蹲后续", "连麦开撕", "正面回应", "爆料现场"];

export const heroStats = [
  { value: "128w+", label: "围观群众" },
  { value: "356", label: "正在跟进事件" },
  { value: "24h", label: "滚动追踪更新" },
];

export const topicList = [
  {
    id: "t1", cat: "蹲后续",
    title: "主播「阿瓜」暂停直播十天后悄悄复播？网友都在蹲回应",
    brief: "停播十天后账号突然开播，弹幕齐刷“等一个解释”，评论区吵翻到底是复出还是清库存。",
    time: "18 分钟前", status: "蹲更中", watch: "96.2w", seed: "chigua-topic-01",
    img: "https://readdy.ai/api/search-image?query=minimal%20flat%20vector%20illustration%20of%20a%20person%20sitting%20on%20a%20stool%20watching%20a%20phone%20showing%20loading%20dots%20with%20a%20floating%20update%20speech%20bubble%2C%20popcorn%20and%20clock%20nearby%2C%20warm%20coral%20red%20and%20soft%20rose%20pink%20on%20warm%20cream%20background%2C%20clean%20editorial%20style%2C%20soft%20grain&width=800&height=520&seq=chigua-topic-01&orientation=landscape",
  },
  {
    id: "t2", cat: "连麦开撕",
    title: "连麦现场火药味拉满：一句话让直播间弹幕原地爆炸",
    brief: "两位主播同框连麦，从带货争议一路聊到人身攻击边缘，主持人三次掐麦才稳住场子。",
    time: "41 分钟前", status: "已连麦", watch: "143w", seed: "chigua-topic-02",
    img: "https://readdy.ai/api/search-image?query=two%20retro%20microphones%20facing%20each%20other%20with%20electric%20spark%20and%20lightning%20between%20them%2C%20clashing%20speech%20bubbles%2C%20warm%20coral%20red%20versus%20hot%20pink%20split%20palette%20on%20warm%20cream%20background%2C%20minimal%20flat%20vector%2C%20clean%20editorial&width=800&height=520&seq=chigua-topic-02&orientation=landscape",
  },
  {
    id: "t3", cat: "正面回应",
    title: "前员工爆料上热搜后，团队官方账号深夜发长文正面回应",
    brief: "被指“管理混乱”之后，官方账号深夜放出员工排班与考勤截图回应，评论区两派互相不服。",
    time: "1 小时前", status: "有更新", watch: "72.4w", seed: "chigua-topic-03",
    img: "https://readdy.ai/api/search-image?query=a%20composed%20person%20raising%20an%20open%20palm%20in%20a%20calm%20reply%20gesture%2C%20floating%20checkmark%20shield%20and%20statement%20paper%2C%20warm%20coral%20and%20soft%20pink%20tones%20on%20warm%20cream%20background%2C%20minimal%20flat%20editorial%20illustration&width=800&height=520&seq=chigua-topic-03&orientation=landscape",
  },
  {
    id: "t4", cat: "爆料现场",
    title: "爆料实锤画面流出：饭圈后援会账目被扒了个底朝天",
    brief: "多名网友贴出活动账单与应援明细对比，直指款项去向不明，粉丝站连夜改公告。",
    time: "2 小时前", status: "热", watch: "201w", seed: "chigua-topic-04",
    img: "https://readdy.ai/api/search-image?query=a%20camera%20with%20a%20bright%20flash%20burst%20and%20scattering%20paper%20documents%2C%20magnifying%20glass%20hovering%20over%20a%20speech%20bubble%2C%20warm%20coral%20red%20and%20rose%20pink%20on%20cream%20background%2C%20flat%20editorial%20style%20with%20soft%20grain&width=800&height=520&seq=chigua-topic-04&orientation=landscape",
  },
  {
    id: "t5", cat: "蹲后续",
    title: "CP 粉急了：两人同框冷脸冲上热搜，蹲一个到底闹没闹掰",
    brief: "晚会现场两人全程零交流，镜头扫过瞬间默契低头，评论区已经开始写同人小作文分析微表情。",
    time: "3 小时前", status: "蹲更中", watch: "310w", seed: "chigua-topic-05",
    img: "https://readdy.ai/api/search-image?query=two%20figures%20standing%20back%20to%20back%20with%20a%20cold%20gap%20between%20them%20and%20a%20ticking%20wall%20clock%2C%20tense%20waiting%20atmosphere%2C%20warm%20coral%20and%20pink%20tones%20on%20cream%20background%2C%20minimal%20flat%20illustration&width=800&height=520&seq=chigua-topic-05&orientation=landscape",
  },
  {
    id: "t6", cat: "连麦开撕",
    title: "带货翻车双方隔空喊话，明晚连麦正面刚你准备好了吗",
    brief: "你卖假一赔十、我骂你赚差价，两位商家隔空喊话约好时间上麦对质，吃瓜群众已搬好小板凳。",
    time: "4 小时前", status: "预告中", watch: "58.7w", seed: "chigua-topic-06",
    img: "https://readdy.ai/api/search-image?query=a%20smartphone%20showing%20a%20split%20screen%20of%20two%20arguing%20avatars%2C%20countdown%20timer%20and%20a%20megaphone%20beside%20it%2C%20warm%20coral%20versus%20hot%20pink%20on%20cream%20background%2C%20flat%20vector%2C%20clean%20editorial&width=800&height=520&seq=chigua-topic-06&orientation=landscape",
  },
  {
    id: "t7", cat: "正面回应",
    title: "被指“摆拍作秀”后，博主晒出完整时间线逐一回应质疑",
    brief: "面对质疑博主没有删评论，反而贴出每一条指控的时间线截图回应，求锤得锤评论区刷起“硬气”。",
    time: "5 小时前", status: "已回应", watch: "84.9w", seed: "chigua-topic-07",
    img: "https://readdy.ai/api/search-image?query=a%20confident%20person%20pointing%20at%20a%20timeline%20board%20covered%20with%20checkmarks%20and%20notes%2C%20proof%20and%20facts%2C%20warm%20coral%20and%20soft%20pink%20tones%20on%20cream%20background%2C%20minimal%20flat%20illustration&width=800&height=520&seq=chigua-topic-07&orientation=landscape",
  },
  {
    id: "t8", cat: "爆料现场",
    title: "神秘小号深夜连环爆料，一串旧视频突然开始疯传",
    brief: "无人认领的小号连发数条所谓“内部聊天记录”，配乐里还藏着引导关注的暗语，疑点重重。",
    time: "7 小时前", status: "存疑待核", watch: "66.3w", seed: "chigua-topic-08",
    img: "https://readdy.ai/api/search-image?query=a%20mysterious%20anonymous%20phone%20profile%20with%20a%20big%20question%20mark%20and%20flying%20secret%20chat%20message%20bubbles%20at%20dusk%2C%20warm%20coral%20glow%20and%20rose%20pink%20on%20deep%20cream%20background%2C%20flat%20editorial%20style&width=800&height=520&seq=chigua-topic-08&orientation=landscape",
  },
];

export const streamScenes = [
  {
    id: "s1", tag: "LIVE", img: "https://readdy.ai/api/search-image?query=dark%20live%20studio%20with%20two%20confrontational%20host%20silhouettes%20in%20coral%20red%20and%20hot%20pink%20neon%20backlight%2C%20debate%20microphones%20and%20floating%20audience%20vote%20bars%2C%20flat%20vector%2C%20high%20energy%20drama%2C%20deep%20charcoal%20background&width=620&height=780&seq=chigua-scene-01&orientation=portrait", host: "吃瓜第一现场",
    title: "两边当事人上麦对质，谁先破防谁就输了",
    desc: "主播连麦双方当事人，引导双方就退款争议逐条对线，直播间实时弹幕投票支持度一路飙升。",
    viewers: "143,208 人在看", next: "19:30 二回战",
  },
  {
    id: "s2", tag: "REPLAY", img: "https://readdy.ai/api/search-image?query=video%20replay%20editing%20room%20showing%20two%20avatar%20screens%20rewinding%20an%20argument%2C%20rewind%20icons%20and%20analysis%20notes%2C%20coral%20red%20and%20rose%20glow%20on%20deep%20charcoal%20background%2C%20flat%20vector%20illustration&width=620&height=780&seq=chigua-scene-02&orientation=portrait", host: "瓜姐聊八卦",
    title: "连线回放：爆料人现场被反将一军",
    desc: "复盘昨晚那场高能连麦，逐帧讲解爆料人话术里的漏洞，还有主持人紧急救场的名场面剪辑。",
    viewers: "58,441 人看过", next: "明晚 20:00 复盘专场",
  },
  {
    id: "s3", tag: "COMING", img: "https://readdy.ai/api/search-image?query=countdown%20calendar%20with%20a%20megaphone%20and%20two%20boxing%20gloves%20about%20to%20meet%2C%20coral%20red%20and%20hot%20pink%20neon%20on%20deep%20charcoal%20background%2C%20flat%20vector%20illustration%2C%20anticipation&width=620&height=780&seq=chigua-scene-03&orientation=portrait", host: "直播间蹲点台",
    title: "蹲点预告：明晚这场隔空喊话可能要动真格",
    desc: "先帮你把两边此前的说法整理成时间线，开播前 30 分钟提前占座，开撕瞬间不错过。",
    viewers: "32,017 人预约", next: "明晚 21:00 准时开",
  },
];

export const services = [
  {
    icon: "ri-eye-line", accent: "primary",
    title: "蹲后续",
    desc: "怕错过反转？帮你把热门事件挂上关注列表，更新第一时间标记，跟紧大部队不掉队。",
  },
  {
    icon: "ri-notification-3-line", accent: "accent",
    title: "催更提醒",
    desc: "当事人迟迟不回应？收集姐妹们的最新进展，动态变化尽收眼底，该出手时就提醒你。",
  },
  {
    icon: "ri-direction-line", accent: "primary",
    title: "求指路",
    desc: "不知道瓜从哪吃起？整理清晰的事件入口与账号合集，一键直达，新瓜友也能无缝跟上。",
  },
  {
    icon: "ri-video-chat-line", accent: "accent",
    title: "连麦现场",
    desc: "主播连麦、开撕、回应、爆料直击，把散落在各直播间的名场面搬到一起慢慢看。",
  },
];

export const guideSteps = [
  { step: "01", title: "看趋势", desc: "点开「热门现场」，浏览正在被围观的榜单事件，一眼锁定今日大瓜。" },
  { step: "02", title: "跟事件", desc: "点进感兴趣的事件卡片，把后续更新加入关注，出现反转自动标「有更新」。" },
  { step: "03", title: "蹲现场", desc: "开播前打开「连麦直击」占好座位，开撕、回应、爆料一个名场面都不错过。" },
  { step: "04", title: "理时间线", desc: "事件复杂也别慌，按时间线整理的「指路合集」帮你把前因后果一次理清。" },
];

export const feedbacks = [
  { name: "蹲到凌晨的薯条", text: "之前老是刷到一半不知道前情，来这里把时间线一拉全明白了，从此吃瓜不迷路！", tag: "新瓜友" },
  { name: "催更大队长", text: "催更功能真的顶，好几次当事人刚发动态我就收到更新，姐妹们都在问我在哪蹲的。", tag: "追更党" },
  { name: "连麦旁观员", text: "把几家直播间的名场面汇总到一块儿看太省事了，二回战都不用我到处找。", tag: "围观党" },
];

export const faqList = [
  {
    q: "吃瓜直播是什么？需要下载软件吗？",
    a: "吃瓜直播是一个把热门娱乐事件聚合分类的围观集合地，网页直接访问即可，无需下载任何软件。我们把事件按「蹲后续、连麦开撕、正面回应、爆料现场」分类，帮你整理事件入口与后续更新，让吃瓜这件事更有条理、不迷路。",
  },
  {
    q: "「蹲后续」是什么意思？要自己每天盯着吗？",
    a: "「蹲后续」指持续关注某个还没结束的热门事件。你可以在事件卡片上把它加入关注，之后相关内容出现更新我们会做标记（如「有更新」「蹲更中」），你随时回来都能看到最新进展，不用自己盯一整天。",
  },
  {
    q: "「催更」和「求指路」有什么区别？",
    a: "「催更」针对的是事件迟迟没有下文、大家希望当事人或整理方尽快更新的情况；「求指路」则是当你刚听说某个瓜、却不知道从哪看起、去哪找原账号时，我们用清晰的入口合集帮你对接上。一个偏催促，一个偏导航。",
  },
  {
    q: "这些事件内容是从哪里来的？可信吗？",
    a: "站内内容来自公开的网络讨论、直播录屏与网友整理的整理稿，属于娱乐资讯的转载与聚合。我们尽量保留原出处并在明显位置标注来源与状态（如「已回应」「存疑待核」），方便你交叉核对。请注意，多数事件仍在进行、信息可能反转，请以当事人与官方口径为准。",
  },
  {
    q: "看到疑似虚假或侵权的内容怎么办？",
    a: "如果你发现某条整理疑似造谣、侵权或侵犯隐私，欢迎通过站内联系入口反馈。我们会对标记为「存疑」的内容下架或加注警示，核实后第一时间处理。也希望大家理性吃瓜，不传播未经证实的信息、不参与网络暴力。",
  },
  {
    q: "为什么我的访问记录/关注列表会消失？",
    a: "关注与足迹是保存在你本机浏览器的临时数据，用于当下访问的便捷体验。如果清除了浏览器缓存或更换设备，记录不会同步。我们建议把重要的「指路合集」收藏保存，方便随时取用。",
  },
];

export const statsBoard = [
  { value: "1200+", label: "已整理事件" },
  { value: "86%", label: "跟进时效" },
  { value: "37", label: "分类栏目" },
  { value: "24/7", label: "滚动更新" },
];

export const friendLinks = ["蹲后续社区", "直播回放库", "指路大全", "名场面合集"];